var map = {
	"./AlgorandWallet.svg": 2796,
	"./Beacon.svg": 2797,
	"./BeaconBlue.svg": 2798,
	"./BitKeep.svg": 2799,
	"./Ledger.svg": 2800,
	"./Maiar.svg": 2801,
	"./MaiarExtension.svg": 2802,
	"./MetaMask.svg": 2803,
	"./MyAlgo.svg": 2804,
	"./Sync2.svg": 2805,
	"./TempleWallet.svg": 2806,
	"./Trezor.svg": 2807,
	"./Tron.svg": 2808,
	"./TronLink.svg": 2809,
	"./TrustWallet.svg": 2810,
	"./WalletConnect.svg": 2811,
	"./kukai.svg": 2812,
	"./wallet.svg": 2813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2795;